import { useState, useEffect } from 'react';

const DAYS = ['monday','tuesday','wednesday','thursday','friday','saturday','sunday'];
const DEFAULT_SLOT = { available: false, start: '08:00', end: '17:00', start2: '', end2: '' };
// Horario que se propone al añadir la segunda franja; el admin lo ajusta.
const DEFAULT_SECOND_RANGE = { start2: '18:00', end2: '21:00' };

export default function AvailabilityEditor({ availability, daysEs, onSave }) {
  const [local, setLocal]     = useState({});
  const [saving, setSaving]   = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError]     = useState('');

  useEffect(() => {
    const init = {};
    DAYS.forEach(d => {
      init[d] = { ...DEFAULT_SLOT, ...(availability?.[d] ?? {}) };
    });
    setLocal(init);
  }, [availability]);

  const toggle = (day) =>
    setLocal(prev => ({ ...prev, [day]: { ...prev[day], available: !prev[day].available } }));

  const setTime = (day, field, value) =>
    setLocal(prev => ({ ...prev, [day]: { ...prev[day], [field]: value } }));

  // Quitarla la envía vacía: el backend combina lo enviado con lo guardado.
  const setSecondRange = (day, range) =>
    setLocal(prev => ({ ...prev, [day]: { ...prev[day], ...range } }));

  const handleSave = async () => {
    setSaving(true);
    setError('');
    setSuccess('');
    try {
      await onSave(local);
      setSuccess('Disponibilidad guardada correctamente');
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError(err.message || 'Error al guardar');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="availability-editor">
      {error   && <div className="alert alert-error">{error}</div>}
      {success && <div className="alert alert-success">{success}</div>}

      <div className="avail-grid">
        {DAYS.map(day => {
          const slot = local[day] ?? DEFAULT_SLOT;
          const hasSecond = Boolean(slot.start2 || slot.end2);
          return (
            <div key={day} className={`avail-row ${slot.available ? 'active' : 'inactive'}`}>
              <label className="day-toggle">
                <input
                  type="checkbox"
                  checked={slot.available}
                  onChange={() => toggle(day)}
                />
                <span className="day-name">{daysEs[day]}</span>
              </label>

              <div className="time-ranges" style={{ opacity: slot.available ? 1 : 0.4, pointerEvents: slot.available ? 'auto' : 'none' }}>
                <div className="time-inputs">
                  <label>
                    Inicio
                    <input
                      type="time"
                      value={slot.start}
                      onChange={e => setTime(day, 'start', e.target.value)}
                    />
                  </label>
                  <span className="separator">—</span>
                  <label>
                    Fin
                    <input
                      type="time"
                      value={slot.end}
                      onChange={e => setTime(day, 'end', e.target.value)}
                    />
                  </label>
                  {!hasSecond && (
                    <button type="button" className="range-toggle" onClick={() => setSecondRange(day, DEFAULT_SECOND_RANGE)}>
                      + Segunda franja
                    </button>
                  )}
                </div>

                {hasSecond && (
                  <div className="time-inputs">
                    <label>
                      Inicio
                      <input
                        type="time"
                        value={slot.start2}
                        onChange={e => setTime(day, 'start2', e.target.value)}
                      />
                    </label>
                    <span className="separator">—</span>
                    <label>
                      Fin
                      <input
                        type="time"
                        value={slot.end2}
                        onChange={e => setTime(day, 'end2', e.target.value)}
                      />
                    </label>
                    <button type="button" className="range-toggle" onClick={() => setSecondRange(day, { start2: '', end2: '' })}>
                      Quitar
                    </button>
                  </div>
                )}
              </div>

              <span className={`status-badge ${slot.available ? 'badge-active' : 'badge-inactive'}`}>
                {slot.available ? 'Activo' : 'Desactivado'}
              </span>
            </div>
          );
        })}
      </div>

      <button className="btn-primary save-btn" onClick={handleSave} disabled={saving}>
        {saving ? 'Guardando...' : 'Guardar disponibilidad'}
      </button>
    </div>
  );
}
